import { render, staticRenderFns } from "./FetchContractsSearch.vue?vue&type=template&id=2b42844b"
import script from "./FetchContractsSearch.vue?vue&type=script&lang=js"
export * from "./FetchContractsSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports